import { useState, Fragment, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingButton from '@mui/lab/LoadingButton';
import { CircularProgress } from "@mui/material";
import img from '../../../assets/images/closed.jpg'
import config from '../../../utils/config'
import ReactGA from "react-ga4";

const steps = ["Etape 1", "Etape 2", "Etape 3"];

const RegisterProfesseur = () => {
  const navigate = useNavigate();

  /**
   * Attributs de l'etape 1
   */
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dateNaissance, setDateNaissance] = useState("");
  const [ville, setVille] = useState("");
  // Résidence (Ville -> Arrondissement -> Quartier) - voir quartiers_data côté API
  const [villeResidence, setVilleResidence] = useState("");
  const [arrondissementResidence, setArrondissementResidence] = useState("");
  const [quartierResidence, setQuartierResidence] = useState("");
  const [adresse, setAdresse] = useState("");
  const [telephone1, setTelephone1] = useState("");
  const [telephone2, setTelephone2] = useState("");
  const [sexe, setSexe] = useState("");

  /** Étape 2 - Spéc. v2 : diplôme, cycle, expérience, références, email optionnel */
  const [dernierDiplome, setDernierDiplome] = useState("");
  const [diplomaDetail, setDiplomaDetail] = useState("");
  const [cyclesEnseignement, setCyclesEnseignement] = useState([]);
  const [experienceParCycle, setExperienceParCycle] = useState({});
  const [referencesPro, setReferencesPro] = useState([{ name: '', number: '' }]);
  const [email, setEmail] = useState("");

  /** Étape 3 */
  const [quartiersAccessibles, setQuartiersAccessibles] = useState([]);
  const [typePieceIdentite, setTypePieceIdentite] = useState("");
  const [diplomeFichier, setDiplomeFichier] = useState(null);
  const [pieceIdentite, setPieceIdentite] = useState(null);
  const [joursDisponibles, setJoursDisponibles] = useState("");
  const [matieresGeneralesEnseignables, setMatieresGeneralesEnseignables] = useState("");
  const [classesGeneralesEnseignables, setClassesGeneralesEnseignables] = useState("");
  const [periodeJournee, setPeriodeJournee] = useState("");

  const [showBtn, setShowBtn] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    setIsLoading(true);
    formData.append("first_name", firstName);
    formData.append("last_name", lastName);
    formData.append("date_naissance", dateNaissance);
    formData.append("adresse", adresse || "");
    formData.append("ville", ville);
    formData.append("ville_residence", villeResidence || "");
    formData.append("arrondissement_residence", arrondissementResidence || "");
    formData.append("quartier_residence", quartierResidence || "");
    formData.append("telephone1", telephone1);
    formData.append("telephone2", telephone2 || "");
    formData.append("sexe", sexe);
    formData.append("email", email || "");
    formData.append("username", telephone1);
    formData.append("cycles_enseignement", JSON.stringify(cyclesEnseignement));
    formData.append("experience_par_cycle", JSON.stringify(experienceParCycle));
    const referencesPayload = (referencesPro || [])
      .map((r) => {
        if (typeof r === 'object' && r !== null) {
          return { name: r?.name || "", number: r?.number || "" };
        }
        return { name: "", number: String(r || "") };
      })
      .filter((ref) => ref.number);
    formData.append("references_pro", JSON.stringify(referencesPayload));
    formData.append("quartiers_accessibles", JSON.stringify(quartiersAccessibles));
    formData.append("dernier_diplome", dernierDiplome);
    formData.append("diploma_detail", diplomaDetail);
    formData.append("type_piece_identite", typePieceIdentite);
    if (diplomeFichier) formData.append("diplome_fichier", diplomeFichier);
    if (pieceIdentite) formData.append("piece_identite", pieceIdentite);
    formData.append("jours_disponibles", joursDisponibles || "");
    formData.append("classes_generales_enseignables", classesGeneralesEnseignables || "");
    formData.append("matieres_generales_enseignables", matieresGeneralesEnseignables || "");
    formData.append("periode_journee", periodeJournee || "");

    const url = `${config.apiUrl}/comptes/register/professeur/`;

    fetch(url, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        return response.json().then((data) => ({ ok: response.ok, status: response.status, data }));
      })
      .then(({ ok, status, data }) => {
        if (ok && status === 201) {
          navigate("/registerProfesseur/success");
        } else {
          setError(data.message || "Une erreur s'est produite, veuillez réessayer.");
          toast.success('Préinscription réussie ! Nous vous contacterons pour le jour de l\'entretien.', {
            position: "top-right",
            autoClose: 8000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            });
          ReactGA.event({
            category: "Auth",
            action: "sign_up_professeur_complete"
          });
          navigate("/");
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setError("Une erreur est survenue, veuillez réessayer plus tard");
        console.log("Erreur => ", error);
        ReactGA.event({
          category: "Auth",
          action: "sign_up_professeur_error",
          label: "network_error"
        });
        setIsLoading(false);
      });
  };


  const handleNext = (e) => {
    e.preventDefault();
    ReactGA.event({
      category: "Navigation",
      action: "navigation_step_professeur",
      label: `step_${activeStep + 1}`
    });
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = (e) => {
    e.preventDefault();
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };
  const enDev = false
  return (

    enDev ? 
    (
      <section className="area-404">
        <div className="d-table">
            <div className="d-table-cell">
                <div className="container">
                    <div className="container text-center">
                        <div className="row">
                            <div className="col-lg-8 error-img">
                                <img src={img} alt="404" />
                                <h4 className='text-center mb-4 mt-n4'>Les inscriptions sont fermées pour l'instant</h4>
                                <Link to="/" className="box-btn">
                                  Retour à l'écran d'accueil
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    )
    :
    (
    <section className="signup-area">
      <ToastContainer />
      <div className="container ">
        <div className="row align-items-center">
          <div class="col-12 col-md-8 offset-md-2">
            <div class="signup-form">
              <h2 className="text-center" style={{fontFamily: 'arial'}}>Préinscription des Professeurs</h2>
              <LoadingButton />
              <Box sx={{ width: "100%", top: "50%" }}>
                <Stepper sx={{ mt: 4 }} activeStep={activeStep}>
                  {steps.map((label, index) => {
                    return (
                      <Step key={index}>
                        <StepLabel>{label}</StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>

                {activeStep === steps.length ? (
                  <Fragment>
                    <Typography sx={{ mt: 2, mb: 1 }}>
                      Votre compte a bien été crée
                    </Typography>
                    <Box sx={{ display: "flex", flexDirection: "row" }}>
                      <Box sx={{ flex: "1 1 auto" }} />
                      <Button onClick={handleReset}>Reset</Button>
                    </Box>
                  </Fragment>
                ) : (
                  <Fragment>
                    <form method="post" className="form-group">
                      {activeStep === 0 ? (
                        <Step1
                          firstName={firstName}
                          lastName={lastName}
                          dateNaissance={dateNaissance}
                          adresse={adresse}
                          ville={ville}
                          villeResidence={villeResidence}
                          setVilleResidence={setVilleResidence}
                          arrondissementResidence={arrondissementResidence}
                          setArrondissementResidence={setArrondissementResidence}
                          quartierResidence={quartierResidence}
                          setQuartierResidence={setQuartierResidence}
                          setError={setError}
                          sexe={sexe}
                          setSexe={setSexe}
                          setFirstName={setFirstName}
                          setLastName={setLastName}
                          setDateNaissance={setDateNaissance}
                          setAdresse={setAdresse}
                          setVille={setVille}
                          setShowBtn={setShowBtn}
                          telephone1={telephone1}
                          telephone2={telephone2}
                          setTelephone1={setTelephone1}
                          setTelephone2={setTelephone2}
                        />
                      ) : activeStep === 1 ? (
                        <Step2
                          setShowBtn={setShowBtn}
                          dernierDiplome={dernierDiplome}
                          setDernierDiplome={setDernierDiplome}
                          diplomaDetail={diplomaDetail}
                          setDiplomaDetail={setDiplomaDetail}
                          diplomeFichier={diplomeFichier}
                          setDiplomeFichier={setDiplomeFichier}
                          cyclesEnseignement={cyclesEnseignement}
                          setCyclesEnseignement={setCyclesEnseignement}
                          experienceParCycle={experienceParCycle}
                          setExperienceParCycle={setExperienceParCycle}
                          referencesPro={referencesPro}
                          setReferencesPro={setReferencesPro}
                          email={email}
                          setEmail={setEmail}
                        />
                      ) : (
                        <Step3
                          ville={ville}
                          quartiersAccessibles={quartiersAccessibles}
                          setQuartiersAccessibles={setQuartiersAccessibles}
                          typePieceIdentite={typePieceIdentite}
                          setTypePieceIdentite={setTypePieceIdentite}
                          pieceIdentite={pieceIdentite}
                          setPieceIdentite={setPieceIdentite}
                          joursDisponibles={joursDisponibles}
                          setJoursDisponibles={setJoursDisponibles}
                          matieresGeneralesEnseignables={matieresGeneralesEnseignables}
                          setMatieresGeneralesEnseignables={setMatieresGeneralesEnseignables}
                          classesGeneralesEnseignables={classesGeneralesEnseignables}
                          setClassesGeneralesEnseignables={setClassesGeneralesEnseignables}
                          periodeJournee={periodeJournee}
                          setPeriodeJournee={setPeriodeJournee}
                          setShowBtn={setShowBtn}
                          setError={setError}
                        />
                      )}

                      <Box
                        sx={{ display: "flex", flexDirection: "row", pt: 2, justifyContent: 'space-between' }}
                      >
                        {
                          activeStep > 0 &&
                        <LoadingButton
                        sx={{backgroundColor: '#1d42d9', borderRadius: 50, height: 50, marginTop: 2, padding: 4, color:'white'}}
                        onClick={handleBack}
                        >
                          Précédent
                        </LoadingButton>
                        }
                        <Box sx={{ flex: "1 1 auto" }} />
                        {activeStep === steps.length - 1 ? (
                          showBtn &&
                          <LoadingButton
                            loading={isLoading}
                            variant='contained'
                            loadingIndicator={<CircularProgress color="inherit" size={30} />}
                            sx={{backgroundColor: '#1d42d9', borderRadius: 50, height: 50, marginTop: 2, padding: 4, color:'white'}}
                            onClick={handleSubmit}
                          >
                            Se préinscrire
                          </LoadingButton>
                        ) : (
                          showBtn && 
                          <LoadingButton
                          sx={{backgroundColor: '#1d42d9', borderRadius: 50, height: 50, marginTop: 2, padding: 4, color:'white'}}
                          onClick={handleNext}
                        >
                          Suivant
                        </LoadingButton>
                        )}
                      </Box>
                      <p style={{ color: "red" }}>{error}</p>
                    </form>
                  </Fragment>
                )}
              </Box>
            </div>
          </div>
        </div>
      </div>
    </section>
    )
  );
};

export default RegisterProfesseur;
